/* eslint-disable no-param-reassign */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-expressions */
import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Table, Button, Collapse, Alert,
} from 'antd';
import dayjs from 'dayjs';
import { LoadingOutlined, CaretRightOutlined, WarningFilled } from '@ant-design/icons';
import PurchaseOrderActions from '@Actions/purchaseOrderActions';
import DocConfigActions from '@Actions/docConfigActions';
import H3Text from '@Uilib/h3Text';
import './style.scss';

const { Panel } = Collapse;

/**
 * @param value
*/
class BulkPreviewPo extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {

      prListColumns: [

        {
          title: 'PRODUCT',
          render: (record) => (
            <H3Text text={record?.product_sku_name} className="prod-table__text" />
          ),
          width: '40%',
        },
        {
          title: 'QUANTITY',
          render: (record) => <div>{`${record?.quantity} ${record?.uom_info?.uqc?.toProperCase() || ''}`}</div>,
          width: '10%',

        },
        {
          title: 'UNIT PRICE',
          render: (record) => this.props.MONEY(record?.price),
          width: '12%',
        },
        {
          title: 'TAX',
          render: (record) => (record?.sellerInfo?.seller_type === 'OVERSEAS' && this.props.user?.tenant_info?.purchase_config?.sub_modules?.vendor?.settings?.hide_tax_for_overseas ? '-' : `${record?.tax_info?.tax_value}%`),
          width: '10%',

        },
        {
          title: 'TOTAL',
          render: (record) => {
            return (this.props.MONEY((record?.quantity * record?.price) * (1 + (record?.tax_info?.tax_value / 100))))
          },
        },

      ],
    };
  }

  componentDidMount() {
    const { prLines, getDocConfig } = this.props;

    const tenantIdsSet = new Set();

    if (prLines) {
      for (let i = 0; i < prLines.length; i++) {
        const line = prLines[i];

        for (let j = 0; j < (line.tenants?.length || 0); j++) {
          const tenantId = line.tenants[j]?.tenantId;
          if (tenantId) {
            tenantIdsSet.add(tenantId);
          }
        }
      }
    }

    const tenantIds = Array.from(tenantIdsSet).join(',');

    getDocConfig(tenantIds, 'PURCHASE_ORDER');
  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    const groupedData = {};
    const termsByTenant = {};

    const tenantIdsSet = new Set();

    if (props?.prLines) {
      for (let i = 0; i < props?.prLines?.length; i++) {
        const line = props.prLines[i];

        for (let j = 0; j < (line.tenants?.length || 0); j++) {
          const tenant = line.tenants[j];
          const tenantId = tenant?.tenantId;
          const deptId = tenant?.tenantDepartmentId;
          const departmentName = tenant?.departmentName;
          const sellerId = tenant?.sellerInfo?.seller_id;

          if (tenantId) {
            tenantIdsSet.add(tenantId);
          }

          const key = `${tenantId}|${deptId}|${sellerId}`;

          if (!groupedData[key]) {
            groupedData[key] = {
              tenant_id: tenantId,
              tenant_department_id: deptId,
              department_name: departmentName,
              seller_id: sellerId,
              tenant_seller_id: tenant?.sellerInfo?.tenant_seller_id,
              seller_info: tenant?.sellerInfo,
              products: [],
            };
          }

          groupedData[key].products.push({
            ...tenant,
            product_sku_id: line.product_sku_id,
            product_sku_name: line.product_sku_name,
            product_sku_info: line.product_sku_info,
          });
        }
      }
    }

    if (props.docConfigPO) {
      const configData = props.docConfigPO?.data?.find(item => item?.document_type === 'PURCHASE_ORDER_DOWNLOAD')?.configuration;

      (configData || []).forEach(cfg => {
        if (cfg?.tenant_id && cfg?.default_t_and_c !== undefined) {
          termsByTenant[cfg.tenant_id] = cfg.default_t_and_c;
        }
      });
    }

    return {
      ...state,
      groupedData: Object.values(groupedData),
      termsByTenant,
    };
  }

  /**
   * @param withApproval
   */
  handleCreatePo(withApproval) {
    const { groupedData = [], termsByTenant } = this.state;
    const { createPurchaseOrder, tenantsConfiguration, callback, user } = this.props;

    const payload = [];

    groupedData.forEach((group) => {
      const prIds = new Set();

      group.products?.forEach((product) => {
        if (product.purchase_requisition_id) {
          prIds.add(product.purchase_requisition_id);
        }
      });

      const purchaseOrder = {
        tenant_seller_id: group.tenant_seller_id,
        tenant_seller_info: {
          tenant_seller_id: group.tenant_seller_id,
          tenant_seller_name: group.seller_info?.seller_name,
          seller_name: group.seller_info?.seller_name,
          seller_id: group.seller_info?.seller_id,
          gst_number: group.seller_info?.gst_number,
        },
        tenant_id: group.tenant_id,
        tenant_department_id: group.tenant_department_id,
        shipping_address_id: user?.user_tenants?.find((tenant) => tenant?.tenant_id === group.tenant_id)?.default_shipping_address_info?.address_id,
        billing_address_id: user?.user_tenants?.find((tenant) => tenant?.tenant_id === group.tenant_id)?.default_billing_address_info?.address_id,
        seller_address_id: group.seller_info?.office_address_details?.address_id,
        payment_terms: [group.seller_info?.default_payment_terms],
        po_date: dayjs().format('YYYY/MM/DD'),
        ref_pr_ids: Array.from(prIds).join(','),
        by_pass_tenant_product_validation: true,
        t_and_c: termsByTenant[group.tenant_id] || '',
        status: withApproval ? 'ISSUED' : 'DRAFT',
        purchase_order_lines: group.products.map((product) => ({
          product_sku_name: product.product_sku_name,
          product_sku_id: product.product_sku_info?.product_sku_id,
          offer_price: product.price,
          quantity: product.quantity,
          tax_id: product.tax_info?.tax_id,
          uom_id: product.uom_info?.uom_id,
          uom_info: [product.uom_info],
          tax_group_info: product.tax_info,
          pr_line_id: product.pr_line_id,
          mo_line_id: product.mo_line_id,
        })),
      };
      payload.push(purchaseOrder);
    });

    createPurchaseOrder(payload, () => {
      this.setState({ actionType: null });
      callback();
    }, false);
  }

  /**
   *
   * @param {*} data
   * @return
   */
  getDataSource(data) {
    return [JSON.parse(JSON.stringify(data))];
  }

  /**
   *
   * @return
   */
  render() {
    const {
      createPurchaseOrderLoading, user,
    } = this.props;

    const {
      groupedData,
      actionType,
      prListColumns,
    } = this.state;

    const tenantMap = {};

    Object.values(groupedData)?.forEach((group) => {
      const tenantId = group?.tenant_id;
      const tenantName = user?.user_tenants?.find((tenant) => tenant?.tenant_id === tenantId)?.tenant_name?.toUpperCase();

      if (!tenantMap[tenantId]) {
        tenantMap[tenantId] = {
          tenant_id: tenantId,
          tenant_name: tenantName,
          sellerGroups: [],
        };
      }

      tenantMap[tenantId].sellerGroups.push(group);
    });

    const groupedByTenant = Object.values(tenantMap);

    return (
      <div className="bulk-pr-verify-container">
        <div className="bulk-pr-verify-title">
          <Alert
            message={`${Object.values(groupedData).length} Purchase Orders`}
            showIcon
            icon={<WarningFilled />}
            type="warning"
          />
        </div>

        {groupedByTenant?.map((tenant) => (
          <div key={tenant.tenant_id}>
            <h3 style={{ marginBottom: '10px', marginTop: '20px', color: '#2D7DF7', fontWeight: 600}}>
              {tenant?.tenant_name}
            </h3>

            {tenant?.sellerGroups.map((group, index) => (
              <Fragment key={`${group.seller_id}-${group.tenant_department_id}-${index}`}>
                <Collapse
                  bordered={false}
                  defaultActiveKey={['1']}
                  expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
                >
                  <Panel
                    header={`${group?.seller_info?.seller_name} (${group.department_name}) - ${group.products?.length} Products`}
                  >
                    <Table
                      bordered
                      showHeader
                      size="small"
                      scroll={{ x: true }}
                      columns={prListColumns}
                      dataSource={group?.products}
                      pagination={false}
                    />
                  </Panel>
                </Collapse>
              </Fragment>
            ))}
          </div>
        ))}

        <div className="custom-drawer__footer" style={{ width: 'calc(100% - 60px)' }}>
          <Button
            type="primary"
            onClick={() => {
              this.setState({ actionType: 'DRAFT' });
              this.handleCreatePo(false);
            }}
            style={{ width: '150px' }}
            disabled={createPurchaseOrderLoading}
          >
            {(createPurchaseOrderLoading && actionType === 'DRAFT') ? <LoadingOutlined /> : 'Save as Draft'}
          </Button>
          <Button
            type="primary"
            onClick={() => {
              this.setState({ actionType: 'ISSUED' });
              this.handleCreatePo(true);
            }}
            style={{ width: '150px', marginLeft: '10px' }}
            disabled={createPurchaseOrderLoading}
          >
            {(createPurchaseOrderLoading && actionType === 'ISSUED') ? <LoadingOutlined /> : 'Save and Issue'}
          </Button>
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({
  UserReducers, PurchaseOrderReducers, TenantReducers, DocConfigReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  createPurchaseOrderLoading: PurchaseOrderReducers.createPurchaseOrderLoading,
  tenantsConfiguration: TenantReducers.tenantsConfiguration,
  docConfigPO: DocConfigReducers.docConfigPO,
  getDocConfigPOLoading: DocConfigReducers.getDocConfigPOLoading,
});

const mapDispatchToProps = (dispatch) => ({
  createPurchaseOrder: (payload, callback, withApproval) => dispatch(PurchaseOrderActions.createPurchaseOrder(payload, callback, withApproval)),
  getDocConfig: (tenantId, entityName, callback) => dispatch(DocConfigActions.getDocConfig(tenantId, entityName, callback)),
});

BulkPreviewPo.propTypes = {
  user: PropTypes.any,
  createPurchaseOrder: PropTypes.func,
  createPurchaseOrderLoading: PropTypes.bool,
  prLines: PropTypes.any,
  callback: PropTypes.func,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(BulkPreviewPo));
